import { Injectable } from '@angular/core';

/**
 * Service to manage the state of accordion items (expanded/collapsed) across the application. This is necessary because when an accordion item is destroyed and re-created (e.g., due to Angular's change detection and component lifecycle), it would lose its state. By storing the state in this service, we can ensure that the expanded/collapsed state of each accordion item is preserved even if the component is re-rendered.
 */
@Injectable({ providedIn: 'root' })
export class AccordionStateService {
  private readonly _states = new Map<string, boolean[]>();

  private readonly _appliedDefaults = new Map<string, boolean[]>();

  getState(widgetId: string | number): boolean[] | undefined {
    return this._states.get(String(widgetId));
  }

  setState(widgetId: string | number, states: boolean[]): void {
    this._states.set(String(widgetId), states);
  }

  getAppliedDefaults(widgetId: string | number): boolean[] | undefined {
    return this._appliedDefaults.get(String(widgetId));
  }

  setAppliedDefaults(widgetId: string | number, defaults: boolean[]): void {
    this._appliedDefaults.set(String(widgetId), defaults);
  }

  clearState(widgetId: string | number): void {
    this._states.delete(String(widgetId));
    this._appliedDefaults.delete(String(widgetId));
  }
}
